import request from '@/utils/request'

export function pageUserMessage (query) {
  return request({
    url: '/user/user-messages/page',
    method: 'get',
    params: query
  })
}

export function getUserMessage (data) {
  return request({
    url: '/user/user-messages/detail',
    method: 'get',
    params: data
  })
}

export function delUserMessage (data) {
  return request({
    url: '/user/user-messages/delete',
    method: 'post',
    data: data
  })
}
